export const getNfuEntregadosMesyPorTipo = (data) => {
    if (!data) return {};

     
    let dataCopy = [...data];

     
    let pltItem = dataCopy.find((item) => item.codigo === "PLT");
    let plt2Item = dataCopy.find((item) => item.codigo === "PLT 2");

     
    if (pltItem && plt2Item) {
        pltItem.cantidad_recolectada += plt2Item.cantidad_recolectada;
         
        dataCopy = dataCopy.filter((item) => item.codigo !== "PLT 2");
    }

     
    const mesesMap = {
        1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr',
        5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Ago',
        9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic'
    };
    

     
    const meses = [...new Set(dataCopy.map((item) => item.id_mes))];

     
    const tiposResiduo = [...new Set(dataCopy.map((item) => item.id_tipo_residuo))].filter(tipo => tipo !== null);

     
    const series = tiposResiduo.map((tipo, index) => {
         
        const codigoResiduo = dataCopy.find(item => item.id_tipo_residuo === tipo)?.codigo || 'Desconocido';

        return {
            name: codigoResiduo,  
            type: "bar",
            stack: 'total',  
            barWidth: '30%',
            data: meses.map(mes => {
                 
                const residuoMes = dataCopy.filter(item => item.id_mes === mes && item.id_tipo_residuo === tipo);
                 
                const totalCantidad = residuoMes.reduce((sum, item) => sum + (item.cantidad_recolectada || 0), 0);
                return totalCantidad;   
            }),
            itemStyle: {
                color: ["#BBCD21", "#AEAEAE", "#39E295", "#caf0f8", "#001219"][index % 5],
            },
        };
    });

    return {
        title: {
            text: "Nfu Entregados Por Mes/Tipo",
            left: "center",
            padding: [20, 10, 10, 10],
            textStyle: { fontSize: Math.max(window.innerWidth * 0.02, 16) },
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
        },
        legend: {
            top: "bottom",
            data: series.map(s => s.name),  
        },
        xAxis: {
            type: "category",
            data: meses.map(mes => mesesMap[mes]),  
            axisLabel: { color: "#000" },
        },
        yAxis: {
            type: "value",
            name: "NFU (UNIDADES)",
            nameLocation: "middle",
            nameTextStyle: { fontSize: 11, padding: [0, 0, 30, 0] },
            axisLabel: {
                color: "#000",
                formatter: (value) => value >= 1000 ? `${value / 1000}k` : value,
            },
            min: 0,
        },
        series: series,
    };
};
